<ng-container *ngIf="(deliveryType$ | async) === 'delivery'">
  <ng-container *ngIf="(isLoading$ | async) === false; else skeleton">
    <ng-container *ngIf="{ addressCityMatches: addressCityMatches$ | async } as cities">
      <ng-container *ngIf="cities.addressCityMatches.length === 0">
        <ng-container *ngIf="isManagerWillClarify$ | async; else slots">
          <sd-manager-will-call></sd-manager-will-call>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #slots>
  <ng-container
    *ngIf="{
      slots: timeSlots$ | async,
      isMobile: isMobile$ | async,
      tabIndex: tabIndex$ | async,
    } as obs"
  >
    <ng-container *ngIf="obs.slots as slots">
      <div *ngIf="slots.length" class="block">
        <h2 *ngIf="obs.isMobile === false">Выбрать дату и время</h2>
        <div class="tabs">
          <ng-container *ngFor="let slotListArray of slots; let i = index">
            <div
              *ngIf="isTabDisabled(slotListArray.date) === false"
              class="tab block-variant"
              [ngClass]="{ active: i === obs.tabIndex }"
              (click)="setCurrentTab(i)"
            >
              {{ slotListArray.date | uiTodayTomorrowDate: 'dd MMMM' : { capitalized: true } }}
            </div>
          </ng-container>
          <ng-container *ngIf="dateRange$ | async as dateRange">
            <div class="tab block-variant date-picker">
              Другой день
              <button
                *ngIf="obs.isMobile; else desktopDatePicker"
                (click)="openModal()"
                class="date-picker-input"
              ></button>
              <ng-template #desktopDatePicker>
                <input
                  class="date-picker-input"
                  ngbDatepicker
                  #d="ngbDatepicker"
                  (dateSelect)="onSelectAnotherDateNgb($event)"
                  [minDate]="ngbDateRangeMin$ | async"
                  [maxDate]="ngbDateRangeMax$ | async"
                  [markDisabled]="ngbDateRangeMarkDisabled"
                  (click)="d.toggle()"
                  navigation="arrows"
                />
              </ng-template>
            </div>
          </ng-container>
        </div>

        <div *ngIf="validationErrors$ | async as errors" class="validation-errors">
          <div *ngFor="let err of errors" class="error-msg alert-danger" role="alert">
            {{ errors }}
          </div>
        </div>

        <ng-container *ngFor="let slotListArray of slots; let i = index">
          <ng-container *ngIf="i === obs.tabIndex">
            <sd-time-slot-groups
              [slotListArray]="slotListArray"
              [currentTimeSlot]="currentTimeSlot$ | async"
              (selectTimeSlot)="setTimeSlot($event)"
            ></sd-time-slot-groups>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #skeleton>
  <div class="block">
    <h2>Выбрать дату и время</h2>
    <div class="skelet variant"></div>
    <div class="skelet variant"></div>
    <div class="skelet variant"></div>
    <div class="skelet variant"></div>
  </div>
</ng-template>
